import { type ComponentRef, Directive, type Type, inject, Input } from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { BoardsViewsContextMenuComponent, type BoardsPanelNavigation } from './boards-views-context-menu/boards-views-context-menu.component';
import { BoardListStore } from '../../services/board-list.store';

/** Opens the Boards view/folder picker from the dynamic panel's header label (`app-dropdown-label`).
 * `stchPopoverTrigger`/`stchPopoverPlacement` stay decorator inputs: they override `PopoverDirective`'s own
 * decorator inputs, which the base reads as plain fields. */
@Directive({
  selector: '[appBoardsViewsContextMenu]',
  standalone: true,
})
export class BoardsViewsContextMenuDirective extends ContextMenuDirective {
  @Input() public override stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() public override stchPopoverPlacement: PopoverPlacement = 'bottomLeft';
  public readonly appBoardsViewsContextMenuOpened = outputFromObservable(this.contextMenuOpened);

  @Input() public appBoardsViewsContextMenuFolders = false;
  @Input() public appBoardsViewsContextMenuNavigate?: (view: BoardsPanelNavigation) => void;

  private readonly listStore = inject(BoardListStore);

  protected registerComponent(): Type<BoardsViewsContextMenuComponent> {
    return BoardsViewsContextMenuComponent;
  }

  protected registerInstance(componentRef: ComponentRef<BoardsViewsContextMenuComponent>): void {
    componentRef.instance.listStore = this.listStore;
    componentRef.instance.foldersOpen = this.appBoardsViewsContextMenuFolders;
    componentRef.instance.navigate = this.appBoardsViewsContextMenuNavigate;
  }
}
